exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".service-table-container[data-v-3a4c9211] {\n  max-height: 600px;\n}\n.service-table-container.with-scroll[data-v-3a4c9211] {\n  overflow-y: scroll;\n}\n.actions-column[data-v-3a4c9211] {\n  width: 100px;\n}\n.icon-style[data-v-3a4c9211] {\n  color: white;\n}\n", ""]);

// exports
